module.exports = __webpack_public_path__ + "static/media/eco-ecology-nature-12-svgrepo-com.74cb9133.svg";